import React from 'react';
import Image from 'next/image';
import type { VideoCourse } from '@/types/video';
import { T } from '@tolgee/react';

const VideoCourseCard: React.FC<{ course: VideoCourse }> = ({ course }) => (
  <div className="mt-5 rounded-2xl bg-gray">
    <div className="w-full h-[375px] relative">
      <Image
        src={course.imageSrc}
        alt={course.imageAlt}
        fill
        className="rounded-2xl object-cover"
      />
      <div className="absolute bottom-5 left-5 p-2.5 rounded-2xl bg-white/50 backdrop-blur-[10px]">
        {course.videos?.data.length} <T>video_details.video_count.videos.label</T> •{' '}
        {course.languages}
      </div>
    </div>
    <div className="p-8">
      <h3 className="text-xl h-20 mb-4">{course.title}</h3>
      <p className="text-base opacity-50">{course.author}</p>
    </div>
  </div>
);

export default VideoCourseCard;
